import { ContextoModuloEnum } from "@/core/domain/enums/privado/aplicacao/modulo/contexto-modulo.enum";
import { AbstractStatusDTOBase } from "../../../abstract-status.dto.base";

export class FuncionalidadeDTO extends AbstractStatusDTOBase {
    moduloId: number;
    moduloNome?: string;
    moduloIcone?: string;
    index: number;
    nome: string;
    contexto: ContextoModuloEnum;
    icone?: string;
    url: string;
    role?: string;
    grupoAcessoNivel?: number;
}
